import React from "react";
import { connect } from "react-redux";
import { changeFeed } from "../../redux/actions/appActions";
import { pageName } from "../../redux/actions/generalActions";
import { AppConfig } from "../../helpers";
import Images from "../common/Images";
import { Enums } from "../../helpers";
import { Button } from "antd";
import { Link } from "react-router-dom";
import {
  getFooterProviders,
  getFooterText,
} from "../../redux/actions/generalActions";
import { Env } from "../../helpers/enums";
import { OnScreenWrapper } from "../";
import moment from "moment";

class Footer extends React.Component {
  componentDidMount() {
    this.props.getFooterProviders();
    this.props.getFooterText();
  }
  handleDocument = (page) => {
    this.props.pageName(page);
    this.props.history.push(`/document/${page}`);
    window.scrollTo(0, 0);
  };

  navigate = (
    route,
    feedId = Enums.Feed.Static,
    feedName = Enums.FeedNames.Static
  ) => {
    const { changeFeed, history } = this.props;
    if (history.location.pathname != route) {
      history.push(`${route}`);
      changeFeed(feedId.toString(), feedName);
      window.scrollTo(0, 0);
    }
  };

  render() {
    const {
      lonestarImage,
      orangeImage,
      tipMeImage,
      voucherImage,
      androidImage,
      appleImage,
      eighteenPlusImage,
      footerProviders,
      apkAndroidLink,
      apkAppleLink,
      footerText,
      socialMedia,
      isDark
    } = this.props;
    return (
      <OnScreenWrapper
        styleFunction={(bool) => ({
          width: "100%",
          height: bool ? "fit-content" : 126,
        })}
      >
        <div className="container desktop">
          <div className="content">
            <hr style={{ opacity: "30%" }} />
            <div className="footer-buttons-icons-wrapper">
            <div className="footer-desktop-provider-logo-container">
              {footerProviders &&
                footerProviders.footerProviders.map((item) => {
                  return (
                    <img
                      key={item.footerProviderID}
                      id={item.footerProviderID}
                      src={`${item.footerProviderName}?id=${item.imageVersion}`}
                      alt="winners-provider"
                    />
                  );
                })}
            </div>
            <div className="footer-buttons-contanier">
              <div>
                {/* todo remove to open apple download */}

                {apkAppleLink ? (
                  <a href={apkAppleLink} target="_blank">
                    <img
                      style={{ height: "70px" }}
                      src={appleImage}
                      alt="apple-image"
                    />
                  </a>
                ) : (
                  <img
                    style={{ height: "70px" }}
                    src={appleImage}
                    alt="apple-image"
                  />
                )}

                {apkAndroidLink ? (
                  <a href={apkAndroidLink} target="_blank">
                    <img
                      style={{ height: "70px" }}
                      src={androidImage}
                      alt="android-image"
                    />
                  </a>
                ) : (
                  <img
                    style={{ height: "70px" }}
                    src={androidImage}
                    alt="android-image"
                  />
                )}
              </div>
            </div>
            <div className="social-media-icons-container">
              {socialMedia &&
                socialMedia.map((item) => {
                  return (
                    <a disabled={!item.link} href={item.link} target="_blank" key={item.imageName}>
                      <img
                        style={{ width: "50px", height: "50px" }}
                        src={
                          isDark
                            ? `${item.imageDarkPath}?id=${item.imageVersion}`
                            : `${item.imageLightPath}?id=${item.imageVersion}`
                        }
                        alt={item.imageName}
                      />
                    </a>
                  );
                })}
            </div>
            </div>
            <hr style={{ opacity: "30%" }} />
            <div className="size">
              <div className="child" />
              <div className="child" style={{ paddingTop: "2rem" }}>
                <div
                  className="link light-on"
                  onClick={() => {
                    this.handleDocument("about-us");
                  }}
                >
                  About Us
                </div>
                <div
                  className="link light-on"
                  onClick={() => {
                    this.navigate("/contact", Enums.Feed.ContactUs);
                  }}
                >
                  Contact Us
                </div>
                {/* <div
                className="link light-on"
                onClick={() => {
                  this.handleDocument("contact-us");
                }}
              >
                Contact Us
              </div> */}
                <div
                  className="link light-on"
                  onClick={() => {
                    this.handleDocument("terms-and-conditions");
                  }}
                >
                  Terms and Conditions
                </div>
                <div
                  className="link light-on"
                  onClick={() => {
                    this.handleDocument("privacy-policy");
                  }}
                >
                  Privacy Policy
                </div>
                <div
                  className="link light-on"
                  onClick={() => {
                    this.handleDocument("responsible-gaming");
                  }}
                >
                  Responsible Gaming
                </div>
                <div
                  className="link light-on"
                  onClick={() => {
                    this.handleDocument("cookies-policy");
                  }}
                >
                  Cookies Policy
                </div>
                <div
                  className="link light-on"
                  onClick={() => {
                    this.handleDocument("general-betting-rules");
                  }}
                >
                  General Betting Rules
                </div>
                <div
                  className="link light-on"
                  onClick={() => {
                    this.handleDocument("how-to");
                  }}
                >
                  How To Play
                </div>

                <div
                  className="link light-on"
                  onClick={() => {
                    this.navigate("/work-with-us", Enums.Feed.WorkWithUs);
                  }}
                >
                  Work With Us
                </div>
                {/* <div
                className="link light-on"
                onClick={() => {
                  this.handleDocument("bumpay-rules");
                }}
              >
                Bumpay Rules
              </div> */}
                <div
                  className="text"
                  style={{
                    opacity: "50%",
                    paddingTop: "3rem",
                    paddingBottom: "2rem",
                  }}
                >
                  {/* {AppConfig.version} */}
                </div>
              </div>
              <div className="child">
                {footerText && footerText.pageText && (
                  <div className="footer-description">
                    <div
                      dangerouslySetInnerHTML={{
                        __html: footerText.pageText || "Unknown Document",
                      }}
                    />
                  </div>
                )}
                <div className="disclamer">
                  <div className="footer-image-container">
                    <img
                      style={{ height: "35px", width: "35px" }}
                      src={eighteenPlusImage}
                      alt="+18-image"
                    />
                  </div>
                  <div className="text">
                    All betting and gambling are forbidden for people under the
                    age of 18
                  </div>
                </div>
              </div>
            </div>
            <hr style={{ opacity: "30%" }} />
            <p style={{ textAlign: "center" }}>
              Version:{AppConfig.version}© {moment().year()} WINNERS INC All
              rights reserved
            </p>
          </div>
        </div>
      </OnScreenWrapper>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    feedId: state.app.feedId,
    lonestarImage: state.general.configuration.lonestarImage,
    orangeImage: state.general.configuration.orangeImage,
    tipMeImage: state.general.configuration.tipMeImage,
    voucherImage: state.general.configuration.voucherImage,
    androidImage: state.general.configuration.androidImage,
    appleImage: state.general.configuration.appleImage,
    eighteenPlusImage: state.general.configuration.eighteenPlusImage,
    socialMedia: state.general.configuration.socialMedia,
    loadingFooterProviders: state.general.loadingFooterProviders,
    footerProvidersError: state.general.footerProvidersError,
    footerProviders: state.general.footerProviders,
    apkAndroidLink: state.general.configuration.apkAndroidLink,
    apkAppleLink: state.general.configuration.apkAppleLink,
    footerText: state.general.footerText,
    isDark : state.app.isDark
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    changeFeed: (feedId) => {
      dispatch(changeFeed(feedId));
    },
    pageName: (page) => dispatch(pageName(page)),
    getFooterProviders: () => dispatch(getFooterProviders()),
    getFooterText: () => dispatch(getFooterText()),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Footer);
